/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionFieldCondition
 */
export interface QuestionFieldCondition {
    /**
     * 
     */
    question_name: string;
    /**
     * 
     */
    selected_values: Array<string>;
}

/**
 * Check if a given object implements the QuestionFieldCondition interface.
 */
export function instanceOfQuestionFieldCondition(value: object): value is QuestionFieldCondition {
    if (!('question_name' in value) || value['question_name'] === undefined) return false;
    if (!('selected_values' in value) || value['selected_values'] === undefined) return false;
    return true;
}

export function QuestionFieldConditionFromJSON(json: any): QuestionFieldCondition {
    return QuestionFieldConditionFromJSONTyped(json, false);
}

export function QuestionFieldConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionFieldCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'question_name': json['question_name'],
        'selected_values': json['selected_values'],
    };
}

export function QuestionFieldConditionToJSON(json: any): QuestionFieldCondition {
    return QuestionFieldConditionToJSONTyped(json, false);
}

export function QuestionFieldConditionToJSONTyped(value?: QuestionFieldCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question_name': value['question_name'],
        'selected_values': value['selected_values'],
    };
}

